var _defs, _rect, _path, _path2, _rect2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCreditCardSmartphoneExchange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".credit-card-smartphone-exchange_svg__credit-card-smartphone-exchange_svg__a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "credit-card-smartphone-exchange_svg__credit-card-smartphone-exchange_svg__a",
    x: 15.75,
    y: 11.25,
    width: 7.5,
    height: 12,
    rx: 1.5,
    ry: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "credit-card-smartphone-exchange_svg__credit-card-smartphone-exchange_svg__a",
    d: "M15.75 20.25h7.5m-19.5-4.5a6 6 0 006 6H12m11.25-13.5a6 6 0 00-6-6h-1.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "credit-card-smartphone-exchange_svg__credit-card-smartphone-exchange_svg__a",
    d: "M17.25.75l-1.5 1.5 1.5 1.5m-6.75 19.5l1.5-1.5-1.5-1.5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "credit-card-smartphone-exchange_svg__credit-card-smartphone-exchange_svg__a",
    x: 0.75,
    y: 0.75,
    width: 12,
    height: 9,
    rx: 1,
    ry: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "credit-card-smartphone-exchange_svg__credit-card-smartphone-exchange_svg__a",
    d: "M.75 3.75h12m-3 3h-3"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGRlZnM+PHN0eWxlPi5he2ZpbGw6bm9uZTtzdHJva2U6Y3VycmVudENvbG9yO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDtzdHJva2Utd2lkdGg6MS41cHg7fTwvc3R5bGU+PC9kZWZzPjxyZWN0IGNsYXNzPSJhIiB4PSIxNS43NSIgeT0iMTEuMjUiIHdpZHRoPSI3LjUiIGhlaWdodD0iMTIiIHJ4PSIxLjUiIHJ5PSIxLjUiLz48bGluZSBjbGFzcz0iYSIgeDE9IjE1Ljc1IiB5MT0iMjAuMjUiIHgyPSIyMy4yNSIgeTI9IjIwLjI1Ii8+PHBhdGggY2xhc3M9ImEiIGQ9Ik0zLjc1LDE1Ljc1YTYsNiwwLDAsMCw2LDZIMTIiLz48cGF0aCBjbGFzcz0iYSIgZD0iTTIzLjI1LDguMjVhNiw2LDAsMCwwLTYtNmgtMS41Ii8+PHBvbHlsaW5lIGNsYXNzPSJhIiBwb2ludHM9IjE3LjI1IDAuNzUgMTUuNzUgMi4yNSAxNy4yNSAzLjc1Ii8+PHBvbHlsaW5lIGNsYXNzPSJhIiBwb2ludHM9IjEwLjUgMjMuMjUgMTIgMjEuNzUgMTAuNSAyMC4yNSIvPjxyZWN0IGNsYXNzPSJhIiB4PSIwLjc1IiB5PSIwLjc1IiB3aWR0aD0iMTIiIGhlaWdodD0iOSIgcng9IjEiIHJ5PSIxIi8+PGxpbmUgY2xhc3M9ImEiIHgxPSIwLjc1IiB5MT0iMy43NSIgeDI9IjEyLjc1IiB5Mj0iMy43NSIvPjxsaW5lIGNsYXNzPSJhIiB4MT0iOS43NSIgeTE9IjYuNzUiIHgyPSI2Ljc1IiB5Mj0iNi43NSIvPjwvc3ZnPgo=";
export { SvgCreditCardSmartphoneExchange as ReactComponent };